import { useState } from "react";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch } from "react-redux";
import { decimalSeparator, thousandSeparator } from "../i18n.js";

export function NumberFormatInfInput({
  value,
  decimalScale = 2,
  prefix = "INF",
  name,
  updateValueCallback,
  defaultINF = Number.MAX_SAFE_INTEGER,
}) {
  const dispatch = useDispatch();
  const [editing, setEditing] = useState(false);

  let isINF = value == Number.MAX_SAFE_INTEGER;

  // react-number-format cannot show a prefix on an empty numeric value (its
  // numeric formatter returns "" before the prefix is applied), so an infinite
  // value (the deepest soil layer's "to", stored as MAX_SAFE_INTEGER) would
  // render as a blank field. Show "INF" as the field's value in a read-only
  // display; focusing it switches to the editable numeric input so a finite
  // boundary can still be typed, and blurring an untouched field restores it.
  if (isINF && !editing) {
    return (
      <input
        type="text"
        className="change-inputTable"
        name={name}
        value={prefix}
        readOnly
        onFocus={() => setEditing(true)}
      />
    );
  }

  let initial = isNaN(value);
  let invalid = "change-input-invalid";
  let valid = "change-inputTable";
  let isInvalid = value == undefined || isNaN(value) || isINF;
  return (
    <NumberFormat
      className={initial ? invalid : valid}
      decimalScale={decimalScale}
      thousandSeparator={thousandSeparator()}
      decimalSeparator={decimalSeparator()}
      displayType="input"
      type="text"
      name={name}
      autoFocus={editing}
      value={isInvalid ? Number.NaN : value}
      onBlur={() => setEditing(false)}
      // Triggers even if the value change was not started by a user action,
      // very different from a normal onChange.
      onValueChange={(values) => {
        const { floatValue } = values;
        if (floatValue !== undefined) {
          dispatch(updateValueCallback(floatValue));
        } else {
          // cleared / non-numeric input falls back to the infinite default
          dispatch(updateValueCallback(defaultINF));
        }
      }}
    />
  );
}
